<template>
	<JBox>
		<!-- Template Info -->
		<CFormInput
			name="passwordLiquid"
			:label="$t('templates.password_liquid')"
			componentName="JInputText"
			v-model="template.passwordLiquid"
		/>
		<!-- Margin -->

		<JHeadline class="s-mt-4 s-mb-1 s-text-lg">{{ $t("templates.spacing") }}</JHeadline>
		<JFlex>
			<CFormInput
				name="marginTop"
				:label="$t('templates.marginTop')"
				componentName="JInputNumber"
				v-model="template.marginSettings.top"
				class="s-mr-8"
			/>
			<CFormInput
				name="marginRight"
				:label="$t('templates.marginRight')"
				componentName="JInputNumber"
				v-model="template.marginSettings.right"
				class="s-mr-8"
			/>

			<CFormInput
				name="marginBottom"
				:label="$t('templates.marginBottom')"
				componentName="JInputNumber"
				v-model="template.marginSettings.bottom"
				class="s-mr-8"
			/>

			<CFormInput
				name="marginLeft"
				:label="$t('templates.marginLeft')"
				componentName="JInputNumber"
				v-model="template.marginSettings.left"
			/>
		</JFlex>

		<JFlex class="s-pt-6 s-pl-1">
			<JLabel class="s-block s-leading-tight s-text-sm s-mt-1 s-font-semibold">{{ $t("templates.advancedSettings") }}</JLabel>
			<JToggle class="s-ml-3" v-model="showAdvanced" @click="toggleAdvanced" />
		</JFlex>

		<!-- Spacing -->
		<JBox v-if="showAdvanced" class="s-mt-2">
			<JText class="s-block s-leading-tight s-px-1 s-font-medium s-pt-2">{{ $t("templates.defineSpacing") }}</JText>
			<JFlex class="s-mt-4 s-w-1/2">
				<CFormInput
					name="header"
					:label="$t('templates.header')"
					componentName="JInputNumber"
					v-model="template.headerSettings.spacing"
					class="s-mr-8"
				/>

				<CFormInput
					name="footer"
					:label="$t('templates.footer')"
					componentName="JInputNumber"
					v-model="template.footerSettings.spacing"
					class="s-mr-4"
				/>
			</JFlex>
		</JBox>
	</JBox>
</template>

<script>
export default {
	props: {
		payload: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			template: null,
			showAdvanced: false
		}
	},
	methods: {
		toggleAdvanced() {
			this.showAdvanced = !this.showAdvanced
		}
	},
	watch: {
		payload: {
			handler() {
				this.template = this.payload
			},
			immediate: true,
			deep: true
		},
		template: {
			handler() {
				this.$emit("input", this.template)
			},
			deep: true
		}
	}
}
</script>
